import React from 'react';

import type { SvgProps } from '../enums';

export const FlagUZ: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55128"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55128)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8H16V12H0V8Z"
        fill="#14DC5A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V5H0V0Z"
        fill="#0099B5"
      />
      <path
        d="M-1 4.625H-1.375V5V8V8.375H-1H17H17.375V8V5V4.625H17H-1Z"
        fill="#F7FCFF"
        stroke="#C51918"
        strokeWidth="0.75"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        // eslint-disable-next-line max-len
        d="M8.36368 1.20043L7.87233 1.47917L8.01266 0.91266L7.542 0.496362H8.15675L8.36294 -0.0397339L8.6047 0.496362H9.12877L8.717 0.91266L8.91499 1.47917L8.36368 1.20043ZM5.84477 2.73761L6.33611 2.45887L6.88742 2.73761L6.68943 2.1711L7.1012 1.7548H6.57714L6.33537 1.21871L6.12919 1.7548H5.51443L5.9851 2.1711L5.84477 2.73761ZM4.48827 3.77656L3.99693 4.05531L4.13726 3.4888L3.66659 3.0725H4.28134L4.48753 2.5364L4.7293 3.0725H5.25336L4.84159 3.4888L5.03958 4.05531L4.48827 3.77656ZM6.36441 3.77874L5.87306 4.05748L6.01339 3.49097L5.54272 3.07467H6.15748L6.36367 2.53858L6.60543 3.07467H7.1295L6.71773 3.49097L6.91572 4.05748L6.36441 3.77874ZM8.36441 3.77874L7.87306 4.05748L8.01339 3.49097L7.54272 3.07467H8.15748L8.36367 2.53858L8.60543 3.07467H9.1295L8.71773 3.49097L8.91572 4.05748L8.36441 3.77874ZM7.84477 2.73761L8.33611 2.45887L8.88742 2.73761L8.68943 2.1711L9.1012 1.7548H8.57714L8.33537 1.21871L8.12919 1.7548H7.51443L7.9851 2.1711L7.84477 2.73761ZM9.87306 4.05748L10.3644 3.77874L10.9157 4.05748L10.7177 3.49097L11.1295 3.07467H10.6054L10.3637 2.53858L10.1575 3.07467H9.54272L10.0134 3.49097L9.87306 4.05748ZM10.3361 2.45887L9.84477 2.73761L9.9851 2.1711L9.51443 1.7548H10.1292L10.3354 1.21871L10.5771 1.7548H11.1012L10.6894 2.1711L10.8874 2.73761L10.3361 2.45887ZM9.87233 1.47917L10.3637 1.20043L10.915 1.47917L10.717 0.91266L11.1288 0.496362H10.6047L10.3629 -0.0397339L10.1568 0.496362H9.542L10.0127 0.91266L9.87233 1.47917ZM12.3644 3.77874L11.8731 4.05748L12.0134 3.49097L11.5427 3.07467H12.1575L12.3637 2.53858L12.6054 3.07467H13.1295L12.7177 3.49097L12.9157 4.05748L12.3644 3.77874ZM11.8448 2.73761L12.3361 2.45887L12.8874 2.73761L12.6894 2.1711L13.1012 1.7548H12.5771L12.3354 1.21871L12.1292 1.7548H11.5144L11.9851 2.1711L11.8448 2.73761ZM12.3637 1.20043L11.8723 1.47917L12.0127 0.91266L11.542 0.496362H12.1568L12.3629 -0.0397339L12.6047 0.496362H13.1288L12.717 0.91266L12.915 1.47917L12.3637 1.20043ZM2.94245 4.12028C2.94245 4.12028 1.73453 3.79267 1.75727 2.58092C1.78002 1.36918 3 1.05458 3 1.05458C2.50151 0.865808 1.02757 1.11911 1.00036 2.56864C0.973155 4.01817 2.47796 4.30373 2.94245 4.12028Z"
        fill="#F7FCFF"
      />
    </g>
  </svg>
);
